import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'i18next';
import { Drawer, Form, Checkbox, Button, Icon } from 'antd';
import { filter, sortBy, find, keyBy, fill, flatten } from 'lodash';
// import actions
import { actions } from 'redux/reports';
// import components
import Title from 'components/Title';
import Counter from 'components/Counter';
// import images
import { useParams } from 'react-router';
import { AddProductForParcellesPopupStyles } from './styles';

const FormItem = Form.Item;

const AddProductForParcellesPopup = ({
  form,
  onClose,
  visible,
  currentParcelleIndex,
}) => {
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [showDrawerInfo, setShowDrawerInfo] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const dispatch = useDispatch();
  const { offlineId } = useParams();
  const newReportsToSync = useSelector((state) =>
    find(state.reports.listNewReportsToSync, (e) => `${e.id}` === offlineId),
  );
  const report = useSelector((state) => state.reports.currentNewReport);
  const currentNewReport = newReportsToSync || report;
  const listProducts = useSelector((state) => state.setting.listProducts);
  const listProductsOrdered = sortBy(
    listProducts,
    (product) => product.sort_order,
  );
  const currentParcelle = currentNewReport?.parcelles[currentParcelleIndex];
  const [productNumber, setProductNumber] = useState(
    keyBy(
      listProducts.map((product) => ({ id: product.id, number: 1 })),
      'id',
    ),
  );
  const { getFieldDecorator } = form;

  const handleSubmit = (e) => {
    e.preventDefault();

    form.validateFields((err, values) => {
      if (!err) {
        let listSelectedProduct = [];
        const listTempProduct = filter(
          listProducts,
          (product) => values.products.indexOf(product.id) !== -1,
        );
        const listSelectedProductNumber = values.products.map(
          (id) => productNumber[id],
        );

        listTempProduct.forEach((product) => {
          const prodNumber = find(
            listSelectedProductNumber,
            (p) => p.id === product.id,
          );
          listSelectedProduct.push(fill(Array(prodNumber.number), product));
        });
        listSelectedProduct = flatten(listSelectedProduct);

        const tempReport = { ...currentNewReport };
        tempReport.parcelles = tempReport.parcelles.map((parcelle, index) => {
          const temp = { ...parcelle };
          if (index === currentParcelleIndex) {
            if (!temp?.products) temp.products = [];
            temp.products = listSelectedProduct;
            return temp;
          }
          return parcelle;
        });

        if (newReportsToSync) {
          dispatch(actions.updateNewReportToSync(tempReport));
          onClose();
          return;
        }

        setIsSubmiting(true);
        dispatch(actions.addNewReport(tempReport))
          .then(() => {
            setIsSubmiting(false);
            onClose();
          })
          .catch(() => {
            setIsSubmiting(false);
          });
      }
    });
  };

  const onUpdateNumber = (id, value) => {
    productNumber[id].number = value;
    setProductNumber(productNumber);
  };

  const onShowDrawerInfo = (info) => () => {
    setSelectedProduct(info);
    setShowDrawerInfo(true);
  };

  const onHideDrawerInfo = () => {
    setShowDrawerInfo(false);
    setSelectedProduct(null);
  };

  return (
    <Drawer
      title="Basic Drawer"
      placement="bottom"
      closable={false}
      onClose={onClose}
      visible={visible}
      height="100%"
      className="full-screen-drawer"
    >
      <AddProductForParcellesPopupStyles>
        <div className="close-div">
          <Button onClick={handleSubmit} type="link" loading={isSubmiting}>
            {i18n.t('createReport.close')}
          </Button>
        </div>
        <Title
          title={i18n.t(
            'createReport.estimatedMarketingStep.addProductPopup.title',
          )}
          subtitle={i18n.t(
            'createReport.estimatedMarketingStep.addProductPopup.subTitle',
          )}
        />
        <Form>
          <div className="content-section">
            <FormItem className="product-section">
              {getFieldDecorator('products', {
                initialValue:
                  currentParcelle?.products?.map((pro) => pro.id) || [],
              })(
                <Checkbox.Group>
                  {listProductsOrdered.map((data, index) => (
                    <label key={index} className="label">
                      <Checkbox value={data.id} />
                      <div>
                        <a href="/#" onClick={onShowDrawerInfo(data)}>
                          <Icon type="info-circle" />
                        </a>
                        <div className="content-product-section">
                          <img
                            src={`${process.env.REACT_APP_CLOUDINARY_URL}/w_400,h_400,c_crop,g_face,r_max/w_100/${data.photo}`}
                            alt={data.nom}
                            title={data.nom}
                          />
                          <div className="name">{data.nom}</div>
                        </div>
                        <Counter
                          productId={data.id}
                          onUpdateNumber={onUpdateNumber}
                        />
                      </div>
                    </label>
                  ))}
                </Checkbox.Group>,
              )}
            </FormItem>
          </div>
        </Form>
        <Drawer
          height="100%"
          className="full-screen-drawer"
          closable
          onClose={onHideDrawerInfo}
          visible={showDrawerInfo}
        >
          <h2>Informations sur le produit</h2>
          {selectedProduct?.informations}
        </Drawer>
      </AddProductForParcellesPopupStyles>
    </Drawer>
  );
};

AddProductForParcellesPopup.propTypes = {
  onClose: PropTypes.func,
  visible: PropTypes.bool,
  form: PropTypes.object,
  currentParcelleIndex: PropTypes.number.isRequired,
};

export default Form.create({ name: 'add_product_popup' })(
  AddProductForParcellesPopup,
);
